// 🚨 AUTO-GENERADO desde SettlementDataType.ts - No editar manualmente

export const SettlementFormDataKeys = [
  "id",
  "tipo",
  "numero",
  "nombre_factura",
  "tel1",
  "tel1_cd",
  "tel2",
  "tel2_cd",
  "email",
  "direccion",
  "fecha",
  "porcenta_descuento",
  "descuento",
  "subtotal",
  "total",
  "impuestos",
  "impuestos_servicio",
  "anulada",
  "tipo_identificacion",
  "identificacion",
  "pagada",
  "status",
  "exenta",
  "exchange_rate",
  "document_comments",
  "customfields",
  "plazo",
  "interest_exempt",
  "selected_logo",
  "clientId",
  "client",
  "currencyId",
  "currency",
  "recibeId",
  "recibe",
  "settlementProducts",
  "settlementPayments",
  "interestEntries",
  "user",
  "razon_social",
  "clientActivitycode",
  "reference_number"
] as const;
